export type SubscriptionBannerVariant = 'trial' | 'pastDueGrace' | 'suspended';

export interface SubscriptionBannerInfo {
  variant: SubscriptionBannerVariant;
  daysRemaining: number | null;
}

export interface SubscriptionBannerSource {
  subscriptionStatus: string;
  trialEndsAt: string | null;
  graceEndsAt: string | null;
}

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function getSubscriptionBannerInfo(
  access: SubscriptionBannerSource | undefined,
  now: Date = new Date(),
): SubscriptionBannerInfo | null {
  if (!access) return null;

  switch (access.subscriptionStatus) {
    case 'Suspended':
      return { variant: 'suspended', daysRemaining: null };
    case 'PastDue':
      return { variant: 'pastDueGrace', daysRemaining: daysUntil(access.graceEndsAt, now) };
    case 'Trialing':
      return { variant: 'trial', daysRemaining: daysUntil(access.trialEndsAt, now) };
    default:
      return null;
  }
}

function daysUntil(deadline: string | null, now: Date): number | null {
  if (!deadline) return null;
  return Math.max(0, Math.ceil((new Date(deadline).getTime() - now.getTime()) / MS_PER_DAY));
}
